import { isOdd } from './is-odd';

export function GetChildMatchCode(code: string): number {
    if (isOdd(code)) {
        return (Number(code) - 1) / 2
    } else if (!isOdd(code)) {
        return Number(code) / 2
    }
}